
    angular.module('qkr').factory('lookupDataUploadService', LookupDataUploadService);

    LookupDataUploadService.$inject = ['$http', 'appConfig'];

    function LookupDataUploadService($http, appConfig) {
        return {
            /** Get all the Lookup beneficiaries */
            loadLookupBeneficiaryInfo() {
                return $http.get(appConfig.apiUrl + 'lookupBeneficiary/listLookupBeneficiaries',
                                    {withCredentials: true}
                                );
            },

            uploadLookupBeneficiaries(selectedFile) {
                const fd = new FormData();
                fd.append('file', selectedFile);
                return $http.post(appConfig.apiUrl + 'lookupDataUpload/uploadLookupBeneficiaryRecord', fd, {
                    transformRequest: angular.identity,
                    headers: {'Content-Type': undefined}
                });
            },

             getUnknownLookupBeneficiaryConfig() {
                return $http.get(appConfig.apiUrl + 'lookupBeneficiary/getUnknownLookupBeneficiaryConfig',
                                    {withCredentials: true});
            },

            saveUnknownLookupBeneficiaryEmailConfig(data) {
                return $http.post(appConfig.apiUrl + 'lookupBeneficiary/updateUnknownLookupBeneficiaryConfig', data);
            },

            updateLookupBeneficiary(lookupBeneficiary) {
                lookupBeneficiary.filterKey = lookupBeneficiary.lastName + lookupBeneficiary.firstName +
                                    lookupBeneficiary.year + lookupBeneficiary.referenceNumber;
                return $http.post(appConfig.apiUrl + 'lookupBeneficiary/updateLookupBeneficiary',
                                        lookupBeneficiary);
            },

            hideLookupBeneficiary(lookupBeneficiary) {
                lookupBeneficiary.filterKey = lookupBeneficiary.lastName + lookupBeneficiary.firstName +
                                    lookupBeneficiary.year + lookupBeneficiary.referenceNumber;
                return $http.post(appConfig.apiUrl + 'lookupBeneficiary/hideLookupBeneficiary',
                                    {id: lookupBeneficiary.beneficiaryId});
            },

            unHideLookupBeneficiary(lookupBeneficiary) {
                lookupBeneficiary.filterKey = lookupBeneficiary.lastName + lookupBeneficiary.firstName +
                                    lookupBeneficiary.year + lookupBeneficiary.referenceNumber;
                return $http.post(appConfig.apiUrl + 'lookupBeneficiary/unHideLookupBeneficiary',
                                    {id: lookupBeneficiary.beneficiaryId});
            },

            loadLookupFinance1Info() {
                return $http.get(appConfig.apiUrl + 'lookupFinance1/listLookupFinances',
                    {withCredentials: true}).then(response => response.data);
            },

            uploadLookupFinance1Record(selectedFile) {
                const fd = new FormData();
                fd.append('file', selectedFile);
                return $http.post(appConfig.apiUrl + 'lookupDataUpload/uploadLookupFinance1Record', fd, {
                    transformRequest: angular.identity,
                    headers: {'Content-Type': undefined}
                });
            },

            getUnknownLookupFinance1Config() {
                return $http.get(appConfig.apiUrl + 'lookupFinance1/getUnknownLookupFinanceConfig',
                    {withCredentials: true});
            },

            saveUnknownLookupFinance1EmailConfig(data) {
                return $http.post(appConfig.apiUrl + 'lookupFinance1/updateUnknownLookupFinanceConfig', data);
            },

            updateLookupFinance1(lookupFinance1) {
                lookupFinance1.filterKey = lookupFinance1.dfNumber + lookupFinance1.stNumber;
                return $http.post(appConfig.apiUrl + 'lookupFinance1/updateLookupFinance1',
                    lookupFinance1);
            },

            updateLookupFinance1(lookupFinance1) {
                lookupFinance1.filterKey = lookupFinance1.dfNumber + lookupFinance1.stNumber;
                return $http.post(appConfig.apiUrl + 'lookupFinance1/updateLookupFinance1',
                    lookupFinance1);
            },

            hideLookupFinance1(lookupFinance1) {
                lookupFinance1.filterKey = lookupFinance1.stLastName + lookupFinance1.stFirstName +
                    lookupFinance1.yearStr + lookupFinance1.stNumber;
                return $http.post(appConfig.apiUrl + 'lookupFinance1/hideLookupFinance1',
                    lookupFinance1);
            },

            unHideLookupFinance1(lookupFinance1) {
                lookupFinance1.filterKey = lookupFinance1.stLastName + lookupFinance1.stFirstName +
                    lookupFinance1.yearStr + lookupFinance1.stNumber;
                return $http.post(appConfig.apiUrl + 'lookupFinance1/unHideLookupFinance1',
                    lookupFinance1);
            },

            addFilterKey(family) {
                return Object.assign({}, family,
                    {filterKey: family.stLastName + family.stFirstName +
                    family.yearStr + family.stNumber + family.dfLastName + family.dfFirstName});
            },

        };
    }




// WEBPACK FOOTER //
// ./src/services/lookup.dataupload.service.js